import { AxiosInstance, AxiosResponse } from "axios";

/**
 * List the tenant's Extender PoP services (one per router; a site with two
 * routers in HA is two rows linked through `haPeer`).
 */
export function fetchExtenderPopList(
  api: AxiosInstance,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/extender-pops?tenantId=${tenantId}&includeChildServices=true`
  );
}

/**
 * Detail of one Extender PoP: router (with interfaces), derived site, HA
 * peer, full carrier legs and subscription term.
 */
export function fetchExtenderPop(
  api: AxiosInstance,
  extenderPopId: number,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/extender-pops/${extenderPopId}?tenantId=${tenantId}`
  );
}

/**
 * The customer ports delivered through the Extended PoP (the KE Ports on
 * its router's interfaces, tenant-scoped).
 */
export function fetchExtenderPopPortsAPI(
  api: AxiosInstance,
  extenderPopId: number,
  tenantId: number
): Promise<AxiosResponse> {
  return api.get(
    `/kontroledge/extender-pops/${extenderPopId}/ports?tenantId=${tenantId}`
  );
}

/**
 * Bandwidth utilization for ONE link of the Extender PoP (a backbone
 * uplink or the HA interconnect), selected by `linkId` from the detail's
 * `links`. Same query modes as the Ports performance endpoint.
 */
export function fetchExtenderPopPerformanceAPI(
  api: AxiosInstance,
  extenderPopId: string,
  linkId: string,
  interval: string,
  tenantId: number,
  timeRange?: string,
  startDate?: string,
  endDate?: string,
  maxPoints?: number
): Promise<AxiosResponse> {
  const params = new URLSearchParams({
    tenantId: String(tenantId),
    linkId,
    interval,
  });
  if (startDate && endDate) {
    params.set("start", startDate);
    params.set("end", endDate);
  } else if (timeRange) {
    params.set("timeRange", timeRange);
  }
  if (maxPoints) {
    params.set("maxPoints", String(maxPoints));
  }
  return api.get(
    `/kontroledge/extender-pops/${extenderPopId}/performance?${params.toString()}`
  );
}
